import React from 'react';
import PropTypes from 'prop-types';

import {withI18n} from 'spa/Components/Context';

@withI18n
class Logo extends React.Component {
  static propTypes = {
    useHeading: PropTypes.bool,
    square: PropTypes.bool,
    style: PropTypes.object,
  };

  render() {
    const {i18n} = this.context;
    const {useHeading = false, square = false, ...rest} = this.props;
    const className = square ? 'logo logo--square' : 'logo';
    const Tag = useHeading ? 'h1' : 'span';

    return (
      <Tag {...rest} className={className}>{i18n._x('Urban', 'Urban logo name')}</Tag>
    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./spa/Components/Header/Logo.jsx